"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOG_ACTIVITY_PROGRESS = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_CATALOG_ACTIVITY_PROGRESS = (0, gql_1.gql)(`
  query CatalogActivityProgress(
    $selectedCatalogId: ID!
    $extractTicketTitle: String!
    $catalogWorkflowTicketTitles: [String!]!
  ) {
    catalog(id: $selectedCatalogId) {
      extractTickets: linkedFrom(
        filter: {
          title: { equals: $extractTicketTitle }
          tasks: { some: { status: { in: PENDING } } }
        }
      ) {
        edges {
          node {
            ticket {
              id
              title
              status
              linkedTo(linkType: MENTION) {
                edges {
                  node {
                    reference {
                      __typename
                      ... on Catalog {
                        id
                      }
                      ... on ProductTreeNode {
                        id
                        title
                        ancestors(first: 100, sort: [ { distance : asc } ]) {
                          edges {
                            node {
                              ancestor {
                                id
                                title
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      openWorkflowTickets: linkedFrom(
        filter: {
          title: { in: $catalogWorkflowTicketTitles }
          status: { in: OPEN }
        }
      ) {
        totalCount
        edges {
          node {
            ticket {
              title
            }
          }
        }
      }
      pendingWorkflowTickets: linkedFrom(
        filter: {
          title: { in: $catalogWorkflowTicketTitles }
          tasks: { some: { status: { in: PENDING } } }
        }
      ) {
        totalCount
        edges {
          node {
            ticket {
              title
              status
            }
          }
        }
      }
      closedWorkflowTickets: linkedFrom(
        filter: {
          title: { in: $catalogWorkflowTicketTitles }
          status: { in: CLOSED }
        }
      ) {
        totalCount
        edges {
          node {
            ticket {
              title
            }
          }
        }
      }
    }
  }
`);
